import {z} from "zod";

export const accountIdsResponse = z.object({
    id: z.string(),
    iqvia_one_key: z.string().optional(),
    de_efn: z.string().optional(),
    updated_at: z.date().optional(),
    created_at: z.date(),
});

export type AccountIdsResponse = z.infer<typeof accountIdsResponse>;

export const accountIdsEntityResponse = z.object({
    id: z.string(),
    iqvia_one_key: z.string().optional(),
    de_efn: z.string().optional(),
    updated_at: z.date().optional(),
    created_at: z.date(),
});

export type AccountIdsEntityResponse = z.infer<typeof accountIdsEntityResponse>;

export const accountIdsByIdRequest = z.object({
    id: z.string().uuid(),
});

export type AccountIdsByIdRequest = z.infer<typeof accountIdsByIdRequest>;

export const accountIdsUpdateRequest = z.object({
    id: z.string().uuid(),
    data: z.object({
        iqvia_one_key: z.string().optional(),
        de_efn: z.string().optional(),
    })
});

export type AccountIdsUpdateRequest = z.infer<typeof accountIdsUpdateRequest>;